<!-- eslint-disable vue/no-v-html -->
<template>
  <LexmeaSearch
    v-slot="{ option }"
    v-model:query="query"
    v-model:selectedItem="model"
    hoverLabel
    :label="$t('legal_text.reference.inputs.norm')"
    prependIcon
    compareBy="id"
    dropdownClasses="max-w-md bg-white"
    dropdownFixed
    :displayValue="displayFn"
    :options="results?.data || ([] as SearchParagraph[])"
    :compact="false"
    :loading="isLoading"
  >
    <span class="block truncate text-sm">
      {{ displayFn(option) }}
    </span>
    <span class="block truncate text-xs" v-html="option.text_highlight" />
  </LexmeaSearch>
</template>

<script lang="ts" setup>
import type { ILegalText } from "~/models/ILegalText";
import type { SearchParagraph } from "~/api/legalTextParagraph";
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";

interface Props {
  modelValue?: ILegalTextParagraph;
  legalText: ILegalText;
}

type Emits = {
  "update:modelValue": [data: ILegalTextParagraph];
};

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const model = useVModel(props, "modelValue", emit);

const query = ref("");

const { data: results, isLoading } = useParagraphSearch(
  toRef(() => query.value.trim()),
  toRef(() => props.legalText.id)
);

const { plainFn: displayFn } = useFullParagraphTitle();
</script>
